/**
 * Size guide drawer (sections/size-in-space.liquid). It follows the selection in
 * <product-purchase> and asks it to change size, so the page and the drawer never disagree.
 */
import { defineElement } from '@wispaire/global';

const BaseElement = globalThis.HTMLElement ?? class {};

class SizeInSpace extends BaseElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');

    this.onTrigger = (event) => {
      const trigger = event.target.closest?.(`[aria-controls="${this.dialog.id}"]`);
      if (trigger) this.open(trigger);
    };
    this.onChange = (event) => {
      if (this.dialog.open) this.render(event.detail.size);
    };
    document.addEventListener('click', this.onTrigger);
    document.addEventListener('product:change', this.onChange);

    // Esc and the close buttons close natively; focus goes back to whatever opened it.
    this.dialog.addEventListener('close', () => this.trigger?.focus());
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
    for (const button of this.querySelectorAll('[data-close]')) button.addEventListener('click', () => this.dialog.close());
    this.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"]')) this.purchase?.selectSize(event.target.value);
    });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onTrigger);
    document.removeEventListener('product:change', this.onChange);
  }

  get purchase() {
    return document.querySelector('product-purchase');
  }

  open(trigger) {
    this.trigger = trigger;
    this.render(this.purchase?.size);
    this.dialog.showModal();
  }

  /** Checks the bar for the selected size and marks its table row. */
  render(size) {
    for (const radio of this.querySelectorAll('input[type="radio"]')) radio.checked = radio.value === size;
    for (const row of this.querySelectorAll('tr[data-value]')) row.toggleAttribute('data-selected', row.dataset.value === size);
  }
}

defineElement('size-in-space', SizeInSpace);
